module.exports = __webpack_public_path__ + "d529ff58a07f4b7e86a6d91b5886985e.svg";